import Quill from 'quill/core';
import React from 'react';
import LinkToolbar from '../../editor/controls/toolbar/LinkToolbar';
import ToolbarPopOver from '../../editor/controls/toolbar/ToolbarPopOver';
import { useQuill } from '../../editor/QuillContext';
import type QuillEditor from '../../editor/QuillEditor';

interface CommentToolbarProps {
  quill: QuillEditor;
}

const CommentToolbar = ({ quill }: CommentToolbarProps) => {
  const {
    selection: { range, formats },
    editingLink: isEditingLink,
  } = useQuill();

  return (
    <ToolbarPopOver portal={document.body}>
      {() =>
        isEditingLink ||
        (formats.link &&
          // Don't show toolbar when the cursor is at beginning to avoid
          // auto focusing brings out the toolbar.
          !(range?.length === 0 && range.index === 0)) ? (
          <LinkToolbar
            quill={quill}
            onLinkChange={(value) =>
              quill.format('link', value, Quill.sources.USER)
            }
          />
        ) : null
      }
    </ToolbarPopOver>
  );
};

export default CommentToolbar;
